jQuery(document).ready(function() {

    jQuery(document).on('gform_confirmation_loaded', function(event, formId){
        // code to be triggered when the confirmation page is loaded
        const form = jQuery('.form-data');
        const formTitle = form.data("title"); // Capture the form name before submission
        const formID = form.data("id");

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': "formSubmission",
            'formID': formID,
            'formName': formTitle // Use the captured formName
        });
    });

});